import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "organic",
  "use": "organic-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"organic\"><g stroke-linecap=\"round\" stroke-width=\"3\" fill=\"none\" stroke=\"currentColor\" stroke-linejoin=\"round\" class=\"nc-icon-wrapper\" transform=\"translate(0.5 0.5)\"><path d=\"M30,47h0A18,18,0,0,0,48,29V17h0A18,18,0,0,0,30,35V47\" data-cap=\"butt\" /> <path d=\"M30,47h0A14,14,0,0,1,16,33V27h0A14,14,0,0,1,30,41v6\" data-cap=\"butt\" /> <circle cx=\"32\" cy=\"32\" r=\"29\" data-cap=\"butt\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol